/* BundleHeader.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';
import { media } from '@atlaskit/primitives/responsive';
import { EyebrowSmall, H3 } from '@atlassian/mpac-primitives';
import { HeaderPartnerDetails } from '@atlassian/mpac-ui';
import BundleIcon from './BundleIcon';
import { CompactAppCard } from './CompactAppCard';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _27 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _26 = "._1wyb1j6v{font-size:1rem}";
const _25 = "._4cvr1h6o{align-items:center}";
const _24 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _23 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _22 = "._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}";
const _21 = "@media (min-width:48rem){._seovu2gc{margin-left:var(--ds-space-100,8px)}}";
const _20 = "._1lhx1h6o>span{align-self:center}";
const _19 = "._9jdd1b66>span{padding-block:var(--ds-space-050,4px)}";
const _18 = "._1o7p1j6v button{font-size:1rem}";
const _17 = "._125m8pqr button{line-height:2.5rem}";
const _16 = "._jq8g8pqr button{height:2.5rem}";
const _15 = "._kewe119w button{padding:0 var(--ds-space-200,1pc)}";
const _14 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _13 = "._vwz41k8s{line-height:1.5rem}";
const _12 = "._19pkv77o{margin-top:var(--ds-space-025,2px)}";
const _11 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _10 = "._19pkidpf{margin-top:0}";
const _9 = "._2hwxpxbi{margin-right:var(--ds-space-200,1pc)}";
const _8 = "@media (min-width:48rem){._1lp7vrvc{flex-direction:row}}";
const _7 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const _6 = "._1n261g80{flex-wrap:wrap}";
const _5 = "._1bah1yb4{justify-content:space-between}";
const _4 = "._19pk1jfw{margin-top:var(--ds-space-500,40px)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
export const BundleHeader = _ref => {
  var _logo$url;
  let {
    name,
    logo,
    partnerName,
    partnerTier,
    apps
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1e0c1txw _2lx21bp4 _19pk1jfw"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2, _5, _6, _3, _7, _8]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1e0c1txw _1bah1yb4 _1n261g80 _2lx21bp4 _1p57xy5q _1lp7vrvc"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_2]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1e0c1txw"]),
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_9]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_2hwxpxbi"]),
                  children: /*#__PURE__*/_jsx(BundleIcon, {
                    icon: "",
                    bundleKey: "",
                    bundleIconLink: (_logo$url = logo === null || logo === void 0 ? void 0 : logo.url) !== null && _logo$url !== void 0 ? _logo$url : ''
                  })
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_10, _11]
                  }), /*#__PURE__*/_jsx(H3, {
                    as: "h1",
                    className: ax(["_19pkidpf _otyr1b66"]),
                    children: name
                  })]
                }), /*#__PURE__*/_jsx(HeaderPartnerDetails, {
                  name: partnerName,
                  link: partnerName,
                  partnerTierType: partnerTier
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_12, _13]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_19pkv77o _vwz41k8s"]),
                    children: "TODO: which field to show here?"
                  })]
                })]
              })]
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_14, _2, _3, _15, _16, _17, _18, _19, _20, _21]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _kewe119w _jq8g8pqr _125m8pqr _1o7p1j6v _9jdd1b66 _1lhx1h6o _seovu2gc"]),
              children: [/*#__PURE__*/_jsx(Button, {
                appearance: "primary",
                children: "Request bundle"
              }), /*#__PURE__*/_jsx(Lozenge, {
                appearance: "success",
                children: "ANNUAL SAVINGS OF 20%"
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4, _22]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_19pk1jfw _otyr1jfw"]),
          children: [/*#__PURE__*/_jsx(EyebrowSmall, {
            children: "CLOUD APPS INCLUDED IN THIS BUNDLE"
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_23, _2, _6, _24]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_zulputpp _1e0c1txw _1n261g80 _19pku2gc"]),
              children: apps.map((_, index) => /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_23, _2, _25]
                }), /*#__PURE__*/_jsxs("div", {
                  className: ax(["_zulputpp _1e0c1txw _4cvr1h6o"]),
                  children: [/*#__PURE__*/_jsx(CompactAppCard, {}), index !== apps.length - 1 && /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_26, _27]
                    }), /*#__PURE__*/_jsx("span", {
                      className: ax(["_1wyb1j6v _syaz131l"]),
                      children: "+"
                    })]
                  })]
                }, index)]
              }, index))
            })]
          })]
        })]
      })]
    })]
  });
};
const HeaderContainerStyles = null;
const HeaderTopRowContainer = null;
const BundleDetailsContainer = null;
const H1Styles = null;
const IconContainer = null;
const CompatibilitiesContainer = null;
const LargePrimaryCTAButtonWrapper = null;
const BundleAppsSection = null;
const BundleAppsContainer = null;
const AppTileContainer = null;
const PlusSign = null;